import React from "react";

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.jsx";

// @material-ui/icons
import Teachers from "@material-ui/icons/Group";
import Parents from "@material-ui/icons/Wc";
import Face from "@material-ui/icons/Face";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";



//images
//import kids13 from "assets/img/kids13.jpg"; backgroundImage: `url(${kids13})`

class SectionProduct extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer>
            <GridItem xs={false} sm={false} md={2}>&nbsp;</GridItem>
            <GridItem xs={12} sm={8} md={8} style={{textAlign:"center", paddingTop:"30px"}}>
              <h2 className={classes.title}>WHAT IS ALL THINGS E.Q.?</h2>
              <h5 className={classes.description} style={{color:"#343434"}}>
                All Things E.Q. is an easy to implement, Social Emotional Program that does NOT give your staff more to do but does create a positive school-wide culture that can be seen, felt and heard on campus.
              </h5>
            </GridItem>
        </GridContainer>

        <div className={classes.container} >
          <div className={classes.features2} style={{marginTop:"0px", paddingTop:"0px"}}>
            
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
                <InfoArea
                  icon={Face}
                  title="Students"
                  description={
                    <span>
                      <p style={{color:'#232323', fontSize:"15px"}}>
                      Students benefit from the weekly insights and enjoy the program. Watching students take ownership in their school and coming to class with a purpose is incredible.  It doesn’t happen overnight, but the culture shifts from “What’s in it for me?” to “How can I help?” and that shift occurs faster when the school has positive student role models on campus.
                      </p>
                    </span>
                  }
                  iconColor="success"
                />
              </GridItem>
              <GridItem xs={12} sm={4} md={4}>
                <InfoArea
                  icon={Teachers}
                  title="Teachers"
                  description={
                    <span>
                      <p style={{color:'#232323', fontSize:"15px"}}>
                        Teachers love how All Thing’s E.Q. changes the way students “show up” in their classroom! Teachers gave All Things E.Q. a 100% approval rating and rated All Things E.Q. with a 4.29 (Very Good) out of 5 (Excellent) in terms of ease of use and implementation.
                      </p>
                    </span>
                  }
                  iconColor="info"
                />
              </GridItem>
              <GridItem xs={12} sm={4} md={4}>
                <InfoArea
                  icon={Parents}
                  title="Parents"
                  description={
                    <span>
                      <p style={{color:'#232323', fontSize:"15px"}}>
                        Parents appreciate being more connected to the school and love getting the weekly parent insights to use at home.  Parents gave a 95% approval rating and shared with teachers that the All Things E.Q. weekly parent insights were well received with a 4.44 (Very Good) out of 5  (Excellent) in terms of creating a positive school community.
                      </p>
                    </span>
                  }
                  iconColor="danger"
                />
              </GridItem>
              
            </GridContainer>
          </div>
        
        </div>
      </div>
    );
  }
}

export default withStyles(featuresStyle)(SectionProduct);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionProduct.jsx